import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FileText, Film, LogOut, Award, Users, Image, ArrowLeftRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AdminHomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuth = sessionStorage.getItem('admin_auth');
    if (!isAuth) {
      navigate('/admin');
    }
  }, [navigate]);

  const logout = () => {
    sessionStorage.removeItem('admin_auth');
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--bk-bg))] p-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h1 className="font-display text-4xl text-[hsl(var(--bk-fg))] mb-2">BAKLIGHT Admin</h1>
            <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">Content Management System</p>
          </div>
          <Button variant="outline" onClick={logout} className="border-[hsl(var(--bk-line))] text-[hsl(var(--bk-fg))]">
            <LogOut size={16} className="mr-2" /> Logout
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link to="/admin/projects">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <Film size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Projects</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Manage work portfolio, project details, capabilities, and credits
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Manage Projects →
              </p>
            </div>
          </Link>

          <Link to="/admin/journal">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <FileText size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Journal</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Create and manage blog articles, categories, and content
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Manage Journal →
              </p>
            </div>
          </Link>

          <Link to="/admin/success-stories">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <Award size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Success Stories</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Manage client success stories for Mexico page
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Manage Success Stories →
              </p>
            </div>
          </Link>

          <Link to="/admin/clients">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <Users size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Clients & Testimonials</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Manage client logos and testimonials for Clients & Trust section
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Manage Clients →
              </p>
            </div>
          </Link>

          <Link to="/admin/mexico-gallery">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <Image size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Mexico Gallery</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Manage homepage Mexico Advantage carousel images
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Manage Gallery →
              </p>
            </div>
          </Link>

          <Link to="/admin/content-sync">
            <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8 hover:border-[hsl(var(--bk-accent))] transition-colors group">
              <ArrowLeftRight size={40} className="text-[hsl(var(--bk-accent))] mb-4" />
              <h2 className="font-display text-2xl text-[hsl(var(--bk-fg))] mb-2">Content Sync</h2>
              <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">
                Export content from Preview → Import to Production
              </p>
              <p className="font-mono-meta text-xs text-[hsl(var(--bk-accent))] mt-4 group-hover:underline">
                Sync Content →
              </p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
